<template>
  <div>
    <v-hover
      v-slot:default="{ hover }"
      :disabled="restrictPlaylistAccess">
      <v-text-field
        class="subtitle-1 resourceText pl-0 mb-1"
        v-model.trim="resource.name"
        :error-messages="resourceNameErrors"
        hide-details="auto"
        dense
        solo
        flat
        :append-icon="hover && !showSlideout ? 'mdi-delete' : ''"
        :disabled="isUpdating || restrictPlaylistAccess || showSlideout"
        @input="$v.resource.name.$touch()"
        @blur="updateResource"
        @keyup.enter="updateResource"
        @click:append="handleRemoveAttachment">
          <v-icon slot="prepend" medium class="pl-2">{{ resourceIcon }}</v-icon>
          {{ resource.name }}
        </v-text-field>
    </v-hover>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions,
} from 'vuex';
// Validations from Vuelidate
import {
  required,
} from 'vuelidate/lib/validators';
import _ from 'lodash';

export default {
  name: 'DraggableResource',
  props:
    [
      'moduleId',
      'resource',
    ],
  data: () => ({
    resourceName: null,
    resourceType: null,
  }),
  computed: {
    ...mapState([
      'isUpdating',
      'passbackBulbs',
      'showSlideout',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
    resourceIcon() {
      if (this.resourceType.includes('pdf')) return 'mdi-pdf-box';
      if (this.resourceType.includes('image')) return 'mdi-image';
      if (this.resourceName.includes('doc')) return 'mdi-file-document-outline';
      return 'mdi-paperclip';
    },
    resourceNameErrors() {
      const errors = [];
      if (!this.$v.resource.name.$dirty) return errors;
      if(!this.$v.resource.name.required) {
        errors.push('Resource name is required.');
      }
      return errors;
    },
  },
  methods: {
    ...mapActions([
      'removeItem',
      'updateResourceName',
    ]),
    handleRemoveAttachment() {
      this.removeItem({
        playlistId: this.playlistId,
        moduleId: this.moduleId,
        oldItemIndex: this.resource.order,
        itemId: this.resource.itemId,
        type: 'attachment',
      });
    },
    updateResource() {
      if (!this.$v.resource.name.$error && this.$v.resource.name.$dirty) {
        this.$v.resource.name.$reset();
        this.updateResourceName(this.resource);
      }
    },
  },
  created() {
    this.resourceName = _.get(this.resource, 'attachment.name') || _.get(this.resource, 'name', '');
    this.resourceType = _.get(this.resource, 'attachment.type', '');
  },
  validations: {
    resource: {
      name: {
        required,
      },
    },
  },
};
</script>

<style>
  .resourceText input {
    font-size: 0.875rem;
    line-height: 1.2 !important;
    color: #000000;
    color: rgba(0, 0, 0, 0.6) !important;
  }
  .v-input__slot {
    padding-left: 2px !important;
  }
</style>
